export const tr = {
    'feed-required': 'Lütfen, beslemeyi kaydedin.',
    'general-rate-max-price': 'Maksimum teklif, {maxValue} {currency} değerini aşmamalıdır',
    'general-rate-min-price': 'Maksimum teklif, {minValue} {currency} değerinin altında olmamalıdır',
    'name-empty': 'Grup adı belirtilmedi'
};
